<template>
    <modal ref="cancelar_tendero" titulo="Cancelar pedido" icon="close" @guardar="cancelar_pedido">
        <ValidationObserver ref="form2">
            <div class="row mx-0 justify-center">
                <div class="col-10 text-center">
                    Es una lástima que quieras cancelar el pedido, cuéntanos por que tomas esta decisión.
                </div>
            </div>
            <div class="row mx-0 my-3 justify-center">
                <div class="col-10">
                    <label>Justificación</label>
                    <ValidationProvider v-slot="{ errors }" rules="required" name="justificacion">
                        <el-input v-model="model.justificacion" type="textarea" show-word-limit maxlength="250" :rows="3" />
                        <span class="text-danger f-11">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
        </ValidationObserver>
    </modal>
</template>

<script>
import Pedidos from '~/services/pedidos/pedidos-admin'
import {mapGetters} from 'vuex'
export default {
    data(){
        return {
            model:{
                justificacion:'',

            },
        }
    },
    computed:{
        ...mapGetters({
            id_pedido: 'pedidos/pedidos_historial_tendero/id_pedido',
        }),
    },
    methods:{
        toggle(){
            this.model = {
                justificacion:''
            }
            this.$refs.cancelar_tendero.toggle()
        },
        async cancelar_pedido(){
            try {
                const valid = await this.$refs.form2.validate()
                if(valid){
                    this.model.id_pedido = this.id_pedido
                    this.model.estado = 26
                    const {data} = await Pedidos.rechazar_cancelar_tendero(this.model)
                    this.$emit('update')
                    this.$store.dispatch('pedidos/pedidos_historial_tendero/pedidos_productos',this.id_pedido)
                    this.$store.dispatch('pedidos/pedidos_historial_tendero/pedidos_historial',this.id_pedido)
                    this.notificacion('Mensaje','Pedido Cancelado','success')
                    this.$refs.cancelar_tendero.toggle()
                }
            } catch (e){
                this.error_catch(e)
            }
        }
    }
}
</script>

<style lang="css" scoped>
</style>
